var I = Object.defineProperty, M = Object.defineProperties;
var S = Object.getOwnPropertyDescriptors;
var d = Object.getOwnPropertySymbols;
var k = Object.prototype.hasOwnProperty, q = Object.prototype.propertyIsEnumerable;
var u = (o, e, r) => e in o ? I(o, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : o[e] = r, l = (o, e) => {
  for (var r in e || (e = {}))
    k.call(e, r) && u(o, r, e[r]);
  if (d)
    for (var r of d(e))
      q.call(e, r) && u(o, r, e[r]);
  return o;
}, f = (o, e) => M(o, S(e));
import { jsxs as w, jsx as P, Fragment as F } from "react/jsx-runtime";
import n from "../../../node_modules/prop-types/index.es.js";
import { useState as s, useEffect as y } from "react";
import { createPortal as N } from "react-dom";
import { usePopper as z } from "react-popper";
import * as B from "./style.es.js";
import { DropdownPopper as G, DropdownPopperArrow as H, Dropdown as J } from "./style.es.js";
import { useOutsideClick as K } from "../../../hooks/useOutsideClick.es.js";
const c = ({
  children: o = () => null,
  dropdownOptions: e = {
    hasPopperArrow: !1
  },
  isMenuOpenDefault: r = !1,
  popperOptions: h = {
    placement: "bottom",
    strategy: "fixed"
  },
  referenceComponent: E = () => null
}) => {
  const [t, p] = s(r), [b, x] = s(null), [A, j] = s(null), [D, O] = s(null), [R, g] = s(null), {
    styles: i,
    attributes: C,
    update: m
  } = z(b, D, l(f(l({}, h), {
    strategy: "fixed"
  }), e.hasPopperArrow ? {
    modifiers: [{
      name: "arrow",
      options: {
        element: R
      }
    }]
  } : {}));
  K({
    current: A
  }, () => p(!1)), y(() => {
    p(r);
  }, [r]), y(() => {
    m && m();
  }, [t, m]);
  const T = /* @__PURE__ */ w(G, f(l({ ref: O, style: i.popper }, C.popper), { isMenuOpen: t, children: [
    o({
      setIsMenuOpen: p,
      isMenuOpen: t,
      setPortalRef: j
    }),
    e.hasPopperArrow && /* @__PURE__ */ P(H, { ref: g, style: i.arrow })
  ] }));
  return /* @__PURE__ */ w(F, { children: [
    /* @__PURE__ */ P(J, { ref: x, children: E({
      setIsMenuOpen: (a) => {
        p(a || !t);
      },
      isMenuOpen: t
    }) }),
    t && N(T, document.body)
  ] });
}, L = {
  children: n.func.isRequired,
  dropdownOptions: n.object,
  isMenuOpenDefault: n.bool,
  popperOptions: n.object,
  referenceComponent: n.func
};
c.S = B;
c.displayName = "DropdownPortal";
c.propTypes = L;
export {
  c as DropdownPortal,
  L as dropdownPortalPropTypes
};
//# sourceMappingURL=DropdownPortal.es.js.map
